import japanese from './locales/ja.js';

export const LANGUAGE_KEY = 'model-vista.language';

export function loadLanguage(storage, browserLanguage = 'en') {
    try {
        const saved = storage?.getItem(LANGUAGE_KEY);
        if (saved === 'en' || saved === 'ja') return saved;
    } catch { /* Storage may be disabled. */ }
    return /^ja(?:-|$)/i.test(browserLanguage) ? 'ja' : 'en';
}

export function saveLanguage(language, storage) {
    try {
        storage.setItem(LANGUAGE_KEY, language);
        return true;
    } catch { return false; }
}

const normalize = value => value.replace(/\s+/g, ' ').trim();
const patterns = Object.entries(japanese).filter(([key]) => key.includes('{')).map(([key, value]) => {
    const names = [];
    const expression = key.split(/(\{\w+\})/).map(part => {
        if (/^\{\w+\}$/.test(part)) {
            names.push(part.slice(1, -1));
            return '(.+?)';
        }
        return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }).join('');
    return { regex: new RegExp(`^${expression}$`), names, value };
});

// Translate only UI-owned strings; asset names and user content stay untouched.
export function translate(language, value, parameters) {
    if (typeof value !== 'string') return value;
    const key = normalize(value);
    let result = language === 'ja' ? (Object.hasOwn(japanese, key) ? japanese[key] : undefined) : value;
    if (language === 'ja' && result === undefined && !parameters) {
        for (const pattern of patterns) {
            const match = key.match(pattern.regex);
            if (match) {
                return pattern.value.replace(/\{(\w+)\}/g, (_, name) => match[pattern.names.indexOf(name) + 1]);
            }
        }
    }
    result = result ?? value;
    return parameters ? result.replace(/\{(\w+)\}/g, (token, name) => parameters[name] ?? token) : result;
}
